import { AvatarStack } from '@factorialco/deprecated-design-system'
import { ReferenceContractsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  levelId: string
  limit: number
}

const LevelEmployees = ({ levelId, limit }: Props) => {
  const { data } = useQuery(ReferenceContractsDocument, {
    variables: {
      levelIds: [levelId],
      limit: limit,
    },
  })

  const referenceContracts = data?.contracts.referenceContractsConnection.nodes || []
  const avatars = referenceContracts.map((contract) => {
    return {
      label: contract.employee?.access.fullName,
      url: '',
    }
  })

  const remaining = (data?.contracts.referenceContractsConnection.totalCount || 0) - limit

  return (
    <AvatarStack
      avatars={avatars}
      size="s24"
      leftover={remaining}
      backgroundColor="champagne1000"
      textSize="200"
      textColor="grey000White"
      overlap="s6"
    />
  )
}

export default LevelEmployees
